import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { BlogSticky } from '@doltech/ui/lib/figma/Blog/BlogSticky';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Separator } from '@doltech/ui/lib/figma/Layout/Landing/Content/Separator';
import { Link } from '@doltech/ui/lib/figma/Link';
import { take } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

const Main = styled(BlogSticky)`
  width: 212px;
  display: none;
  gap: 24px;
  grid-template-columns: 1fr;
  ${fromScreen(1280)} {
    display: grid;
  }
  .title-container {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    padding-left: 12px;
    border-left: 3px solid ${colorsV2.green100};
  }
  .page-list {
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr;
  }
  .page-list-item {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;

    > a {
      color: ${colorsV2.black100};
    }
  }
`;

interface PageListItem {
  id: string;
  title: string;
  url: string;
}

interface SideBarPageListProps {
  title: string;
  pageList: PageListItem[];
}

export const SideBarPageList = ({ title, pageList }: SideBarPageListProps) => {
  const { appScrollRef } = useAppScrollRef();
  return (
    <Main
      stickyId="right-interaction-sidebar"
      scrollContainerElm={appScrollRef.current}
      stickOnElm=".right-sidebar-stick"
      hideWhenIntersectWithElms={[
        '#footer-author',
        '#footer-author + *',
        '#content-footer',
        '#compact-footer',
        '.common-footer',
        '#extra-sections',
        '.footer-with-register',
      ]}
      offsetY={144}
      stickOnElmPosition={{
        align: 'left',
        gapInPx: 56,
      }}
      stickyMode="ALWAYS_SHOW"
      className="sidebar-page-list"
    >
      <div className="title-container">{title}</div>
      <div className="page-list">
        {take(pageList, 5).map((pageItem, pageItemIndex) => {
          const { id, url } = pageItem;
          return (
            <React.Fragment key={id + pageItemIndex}>
              <div key={id} className="page-list-item">
                <Link target="_blank" href={url}>
                  <div className="list-item-title">{pageItem.title || '...'}</div>
                </Link>
              </div>
              {pageItemIndex < pageList.length - 1 && <Separator variant="horizontal" key={id} />}
            </React.Fragment>
          );
        })}
      </div>
    </Main>
  );
};
